import React, { Component } from 'react';
import PropTypes from 'prop-types';
import s from "./tabs.module.css";
import slugify from "slugify"
import { GTMEvents } from '../../lib/GTMevents';


class Tab extends Component {
  static propTypes = {
    activeTab: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    GTMoption: PropTypes.any
  };

  onClick = () => {
    const { label, onClick, GTMoption } = this.props;
    onClick(label);
    GTMEvents.ButtonTabRetirement25(GTMoption.section,GTMoption.sub_section,label, GTMoption.local )
  }

  render() {
    const { 
      onClick,
      props: {
        activeTab,
        label,
        behavior,
        layout,
        icon,
        isFill,
        isDisabled
      },
    } = this;

    let className = layout === 'full-width' ? s.tabitemFull : `${s.tabitem} bg-gray-1`;




    if (activeTab === label) {
      if (behavior === 'steps') {
        className += `${s.tabitemFull} fw-1 ${s.tabitemFull_active}`
      }
      else if (behavior !== 'steps'){
        className += `${s.tabitemFull} fw-1 ${s.tabitemFull_active}`
      }
      
    }
    if (isDisabled && behavior === 'steps'){
      className += ` ${s.tabDisabled}`
    }

    if (isFill && behavior === 'steps'){
      className += ` ${s.tabPrevFilled}`
    }


    return (
      <li
        id={slugify(`${label}`,{lower:true})}
        className={`center justify-center pv-3 ph-2 flex items-center ${className}`}
        onClick={onClick}
      >
        {icon ? icon : null}
        <span className='ml-2'>{label}</span>
      </li>
    );
  }
}


export default Tab;
